
/**
 * Essenciata Wishlist Management (Coleção Privée)
 * Lógica de persistência em LocalStorage
 */

const EssenciataWishlist = {
  key: 'essenciata_wishlist',

  get() {
    try {
      return JSON.parse(localStorage.getItem(this.key) || '[]');
    } catch (e) {
      return [];
    }
  },

  toggle(handle) {
    let wishlist = this.get();
    const index = wishlist.indexOf(handle);
    
    if (index === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(index, 1);
    }
    
    localStorage.setItem(this.key, JSON.stringify(wishlist));
    this.updateIcons();
    return wishlist;
  },

  updateIcons() {
    const wishlist = this.get();
    const icons = document.querySelectorAll('.card-wishlist-icon');
    
    icons.forEach(icon => {
      const handle = icon.dataset.productHandle;
      const heart = icon.querySelector('.wishlist-heart');
      
      if (wishlist.includes(handle)) {
        icon.classList.add('active');
        if (heart) {
          heart.setAttribute('fill', '#8E6CCF');
          heart.setAttribute('stroke', '#8E6CCF');
        }
      } else {
        icon.classList.remove('active');
        if (heart) {
          heart.setAttribute('fill', 'none');
          heart.setAttribute('stroke', 'currentColor');
        }
      }
    });
  },

  init() {
    this.updateIcons();
    
    // Delegação de evento para cliques em corações
    document.body.addEventListener('click', (e) => {
      const icon = e.target.closest('.card-wishlist-icon');
      if (icon) {
        e.preventDefault();
        e.stopPropagation();
        const handle = icon.dataset.productHandle;
        this.toggle(handle);
        
        // Animação de pulso
        icon.style.transform = 'scale(1.4)';
        setTimeout(() => {
          icon.style.transform = 'scale(1)';
        }, 300);
      }
    });

    // Observer para carregar ícones em carrosséis dinâmicos ou lazy loading
    const observer = new MutationObserver(() => this.updateIcons());
    observer.observe(document.body, { childList: true, subtree: true });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  EssenciataWishlist.init();
});
